// extracted by mini-css-extract-plugin
export default {"facts__highlight":"B1cQ5bB","facts__subline":"WVlrSjd"};